import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { oktaTokenBaseQuery } from "@/react/services/api";
import { HttpMethods } from "@/react/http";

export const addressValidationApi = createApi({
  reducerPath: "addressValidationApi",
  baseQuery: oktaTokenBaseQuery(),
  endpoints: (builder) => ({
    validateFreeformAddress: builder.mutation({
      query: ({ freeForm, country }) => ({
        url: `/v1/address-management/validate`,
        method: HttpMethods.POST,
        body: { freeForm, country },
      }),
    }),
    validateAddress: builder.mutation({
      query: ({ address }) => ({
        url: `/v1/address-management/validate/full`,
        method: HttpMethods.POST,
        body: address,
      }),
    }),
  }),
});

export const {
  useValidateFreeformAddressMutation,
  useValidateAddressMutation,
} = addressValidationApi;
